import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, ArrowRight, GraduationCap, Heart, Compass } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/api";
import { VideoCarousel } from "@/components/VideoCarousel";

export default function Sobre() {
  return (
    <div data-testid="page-sobre">
      <section className="section">
        <div className="container-narrow grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_escuta-acolhimento/artifacts/b334ifpq_foto%20profissional%203.png"
              alt="Cristina Moreira"
              className="w-full h-[420px] sm:h-[520px] md:h-[620px] object-contain object-bottom"
              data-testid="sobre-image"
            />
            <VideoCarousel />
          </div>
          <div className="lg:col-span-7">
            <span className="text-eyebrow">Sobre Mim</span>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl mt-5 leading-[1.1] text-[#2C352D]">
              Sou Cristina Moreira,<br /> psicanalista clínica.
            </h1>
            <p className="mt-3 text-[#8BA88E] font-medium tracking-wider text-sm" data-testid="sobre-cbpc">
              CBPC 2022-5725
            </p>
            <div className="mt-8 prose-soft">
              <p>
                Acredito que a escuta cuidadosa permite que cada sujeito encontre novos significados
                para sua história, suas dores e seus desejos. Meu trabalho oferece um espaço seguro
                para falar, refletir e elaborar conflitos emocionais.
              </p>
              <p>
                A psicanálise, para mim, é uma forma ética e profunda de cuidar do humano. É no encontro
                entre quem fala e quem escuta com atenção que algo se desloca — abrindo caminho para o
                que estava paralisado.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-6 mt-12">
              <div className="bg-white rounded-2xl p-8 border border-[#8BA88E]/15 soft-shadow">
                <GraduationCap className="text-[#8BA88E]" size={26} />
                <h3 className="font-serif text-2xl mt-4 text-[#2C352D]">Formação</h3>
                <p className="mt-3 text-[#5B685C] font-light leading-relaxed">
                  Formação em Psicanálise Clínica, com estudos continuados em teoria psicanalítica
                  freudiana e lacaniana, supervisão clínica e participação em grupos de estudo.
                </p>
                <p className="mt-4 text-xs uppercase tracking-widest text-[#8BA88E] font-medium">
                  Registro CBPC 2022-5725
                </p>
              </div>
              <div className="bg-white rounded-2xl p-8 border border-[#8BA88E]/15 soft-shadow">
                <Heart className="text-[#8BA88E]" size={26} />
                <h3 className="font-serif text-2xl mt-4 text-[#2C352D]">Experiência clínica</h3>
                <p className="mt-3 text-[#5B685C] font-light leading-relaxed">
                  Atendimentos a adultos e adolescentes, com escuta dedicada a quadros de ansiedade,
                  angústia, conflitos familiares, sentimentos de vazio e processos de autoconhecimento.
                </p>
              </div>
              <div className="bg-white rounded-2xl p-8 border border-[#8BA88E]/15 soft-shadow">
                <Compass className="text-[#8BA88E]" size={26} />
                <h3 className="font-serif text-2xl mt-4 text-[#2C352D]">O que me trouxe à psicanálise</h3>
                <p className="mt-3 text-[#5B685C] font-light leading-relaxed">
                  O encantamento pela escuta — pela ideia de que cada pessoa porta um saber sobre si
                  que, na fala, pode ganhar contorno e direção.
                </p>
              </div>
              <div className="bg-white rounded-2xl p-8 border border-[#8BA88E]/15 soft-shadow">
                <Compass className="text-[#8BA88E]" size={26} />
                <h3 className="font-serif text-2xl mt-4 text-[#2C352D]">Como trabalho</h3>
                <p className="mt-3 text-[#5B685C] font-light leading-relaxed">
                  Atendimento online, sigiloso, com frequência semanal e tempo respeitoso para cada
                  sujeito. Sem julgamentos, sem pressa: a fala como caminho.
                </p>
              </div>
            </div>

            <div className="mt-12 flex flex-wrap gap-4">
              <a
                data-testid="sobre-whatsapp-btn"
                href={WHATSAPP_LINK()}
                target="_blank"
                rel="noreferrer"
                className="btn-whatsapp"
              >
                <MessageCircle size={18} /> Agendar conversa
              </a>
              <Link data-testid="sobre-contato-link" to="/contato" className="btn-outline">
                Página de contato <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
